/**
 * @desc 列表
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(body: defs.fulfilment.WarehouseRulesRequestParamsDto, options?: any) {
  return updateResponse(
    http(URL + `/warehouseRules/list`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
